import { ReactNode } from 'react'
import { DataTableRow } from '@boltenergy-be/design-system/dist/components/data-table/types'
import { NestedDataTableColumn, NestedDataTableRow } from './types.ts'

/**
 * Maps a row to the shape the design system table expects. Every row gets an entry for every column, in the order of
 * the columns, because the table reads its headers and its cell order from the entries of the first row
 * @param {NestedDataTableRow} row
 * @param {NestedDataTableColumn[]} columns
 * @param {ReactNode} expandCell
 */
export const toDataTableRow = (row: NestedDataTableRow, columns: NestedDataTableColumn[], expandCell: ReactNode): DataTableRow<string> => ({
  id: row.id,
  uuid: row.id,
  entries: {
    __expand: { header: '', content: expandCell },
    ...Object.fromEntries(columns.map(({ key, header, align }) => [key, { header, align, content: row.cells[key] ?? '' }]))
  }
})
